import React from "react";
import "./postListStyles.css";

export type BlogFooterPostsSectionProps = {
  archiveLinks: {
    label: string;
    url: string;
  }[];
};

const shopNowCategories = [
  { name: "Restaurant Equipment", url: "/restaurant-equipment.html" },
  { name: "Food & Beverage", url: "/restaurant-consumables.html" },
  { name: "Janitorial Supplies", url: "/restaurant-janitorial-supplies.html" },
  { name: "Industrial Equipment", url: "/industrial-supplies.html" },
  { name: "Coffee Shop Supplies", url: "/coffee-shop-supplies.html" },
  { name: "Bakery Supplies", url: "/bakery-supplies.html" },
  { name: "Bar Supplies", url: "/bar-supplies.html" },
  { name: "Ice Cream Shop Supplies", url: "/ice-cream-shop-supplies.html" },
];

const BlogFooterPostsSection = ({
  archiveLinks,
}: BlogFooterPostsSectionProps) => {
  return (
    <div className="footer-posts-container border border-solid border-gray-200 flex items-start justify-start w-full xl:border-b-0">
      <div className="footer-shop-now flex flex-col gap-2 px-4 md:px-6 xl:px-4 py-6">
        <h4 className="font-bold leading-[33px] text-2xl text-gray-800 m-0 p-0">
          Shop Now
        </h4>
        <ul className="blog-footer-list font-sm mb-0 text-green-600 pl-6">
          {shopNowCategories.map((category) => (
            <li key={category.url} className="xl:h-[23px]">
              <a
                className="leading-5 hover:underline"
                href={category.url}
                style={{ color: "#257600", fontSize: "14px" }}
              >
                {category.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="footer-archive flex flex-col gap-2 px-4 py-6 m-0 p-0">
        <h4 className="font-bold leading-[33px] text-2xl text-gray-800 m-0 p-0">
          Archives
        </h4>
        <ul className="blog-footer-list mb-0 text-green-600 pl-6">
          {archiveLinks.map((link) => (
            <li key={link.url} className="xl:h-[23px]">
              <a
                className="leading-5 hover:underline"
                href={link.url}
                style={{ color: "#257600", fontSize: "14px" }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default BlogFooterPostsSection;
